import React from 'react';

type Props = {
  children: React.ReactNode;
  reference: React.RefObject<HTMLDivElement | null>;
  className?: string;
};

function StyledModal({ children, reference, className = '' }: Props) {
  return (
    <div
      ref={reference}
      className={`bg-surface-elevated w-full overflow-y-auto shadow-lg ${className}`}
    >
      <div className="mx-auto mt-3 mb-4 h-1 w-10 rounded-full bg-neutral-300" />
      {children}
    </div>
  );
}

export default StyledModal;
